"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _DetailsTooltip = _interopRequireDefault(require("./DetailsTooltip"));

var _Button = _interopRequireDefault(require("../buttons/Button"));

var _ButtonGroup = _interopRequireDefault(require("../layout/ButtonGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

"use strict";

/**
* @callback CancelTooltip~onCancel
*/

/**
* @callback CancelTooltip~onConfirm
*/

/**
 * @class CancelTooltip
 * @desc CancelTooltip implements tooltip used to confirm or deny the canceling of an action.
 *
 * @param {string} [data-id]
 *     The data-id of the component.
 * @param {string} cancelButtonText
 *     The text of the cancel link.
 * @param {string} confirmButtonText
 *     The text of the confirm button.
 * @param {string} messageText
 *     The text to display in the body of the tooltip.
 * @param {string} [positionClassName]
 *     CSS classes to set on the top-level HTML container. Used to manage tooltip callout positioning with the
 *     CancelTooltip.positionStyles enum and/or any extra css styling if needed.
 * @param {DetailsTooltip.tooltipPlacements} [placement]
 *     How the tooltip is placed off of its trigger.
 * @param {string} title
 *     The title of the details tooltip.
 *
 * @param {boolean} open
 *     The prop that controls whether the tooltip is visible or not
 *
 * @param {CancelTooltip~onCancel} onCancel
 *     The callback triggered when the cancel button is pressed.
 * @param {CancelTooltip~onConfirm} onConfirm
 *     The callback triggered when the confirm button is pressed.
 *
 * @example
 *     <CancelTooltip
 *          title={this.im("pingid.policies.deleterule.label")}
 *          label={this.im("pingid.policies.deleterule.title")}
 *          open={this.state.isInviteOpen} onToggle={this._handleToggle}
 *          disabled={false}>
 *              <p>what ever callout content is</p>
 *     </CancelTooltip>
 */
var CancelTooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CancelTooltip, _React$Component);

  var _super = _createSuper(CancelTooltip);

  function CancelTooltip() {
    (0, _classCallCheck2.default)(this, CancelTooltip);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CancelTooltip, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_DetailsTooltip.default, {
        "data-id": this.props["data-id"] + "-cancel-tooltip",
        className: "cancel-tooltip",
        label: this.props.label,
        open: this.props.open,
        positionClassName: this.props.positionClassName,
        placement: this.props.placement,
        showClose: false,
        title: this.props.title
      }, /*#__PURE__*/_react.default.createElement("p", {
        "data-id": this.props["data-id"] + "-cancel-tooltip-text"
      }, this.props.messageText), /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "cancel",
        "data-id": this.props["data-id"] + "-cancel-confirm-btn",
        onClick: this.props.onConfirm
      }, this.props.confirmButtonText), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
        className: "cancel",
        "data-id": this.props["data-id"] + "-cancel-deny-btn",
        onClick: this.props.onCancel
      }, this.props.cancelButtonText)));
    }
  }]);
  return CancelTooltip;
}(_react.default.Component);

(0, _defineProperty2.default)(CancelTooltip, "propTypes", {
  "data-id": _propTypes.default.string,
  cancelButtonText: _propTypes.default.string.isRequired,
  confirmButtonText: _propTypes.default.string.isRequired,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onConfirm: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  positionClassName: _propTypes.default.string,
  placement: _propTypes.default.oneOf((0, _values.default)(_DetailsTooltip.default.tooltipPlacements))
});
module.exports = CancelTooltip;